import { useEffect, useState } from "react";
import {
  getCachedDocumentPreview,
  loadDocumentPreview,
} from "../utils/documentPreviewCache";

export default function useDocumentPreview(documentName) {
  const [excerpt, setExcerpt] = useState(() => getCachedDocumentPreview(documentName));
  const [loadingExcerpt, setLoadingExcerpt] = useState(
    () => Boolean(documentName) && !getCachedDocumentPreview(documentName)
  );

  useEffect(() => {
    let cancelled = false;

    if (!documentName) {
      setExcerpt("");
      setLoadingExcerpt(false);
      return undefined;
    }

    const cached = getCachedDocumentPreview(documentName);
    if (cached) {
      setExcerpt(cached);
      setLoadingExcerpt(false);
      return undefined;
    }

    setLoadingExcerpt(true);

    loadDocumentPreview(documentName)
      .then((text) => {
        if (!cancelled) {
          setExcerpt(text);
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoadingExcerpt(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [documentName]);

  return { excerpt, loadingExcerpt };
}
